const Ontomate = () => {
  return (
    <div>
      <h4>Ontomate flags go here</h4>
      <p>Text mining information from Ontomate</p>
    </div>
  )
}

export default Ontomate
